"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const pulse_components_1 = require("@pcs/pulse-components");
const react_1 = __importStar(require("react"));
const moment_1 = __importDefault(require("moment"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const react_redux_1 = require("react-redux");
const union_1 = __importDefault(require("lodash/union"));
const StageSettings_1 = __importDefault(require("../../../reviews-modal/components/ShareForReview/Overview/ReviewStage/StageSettings"));
const store_1 = require("../../../reviews-modal/store");
const sliceReview_1 = require("../../../reviews-modal/slice/sliceReview");
const helper_1 = require("../../helper");
const selectors_1 = __importDefault(require("../../../reviews-modal/slice/selectors"));
const constants_1 = require("../../../reviews-modal/slice/sliceReview/constants");
const SegmentedControl_1 = __importDefault(require("../SegmentedControl"));
const PulseStageSelect_1 = __importDefault(require("./PulseStageSelect"));
const useStageTriggerTypes_1 = __importDefault(require("../../hooks/useStageTriggerTypes"));
const styles_modules_less_1 = __importDefault(require("./styles.modules.less"));
const IMMEDIATE_TRIGGER_TYPE = 'immediately';
const MANUALLY_TRIGGER_TYPE = 'manually';
const WHEN_TRIGGER_TYPE = 'when';
const groupButtons = [
    {
        title: 'Immediately',
        value: IMMEDIATE_TRIGGER_TYPE,
        icon: 'fa-light fa-chevrons-right',
    },
    {
        title: 'When',
        value: WHEN_TRIGGER_TYPE,
        icon: 'fa-light fa-code-merge',
    },
    {
        title: 'Manually',
        value: MANUALLY_TRIGGER_TYPE,
        icon: 'fa-solid fa-play',
    },
];
const TriggerStateModal = (props) => {
    var _a;
    const { triggerStateModal, setTriggerStateModal, formikProps } = props;
    const handleCloseModal = () => {
        setTriggerStateModal((stage) => {
            return { ...stage, isOpen: false };
        });
    };
    const [statusStrategyOptions, setStatusStrategyOptions] = (0, react_1.useState)([]);
    const statusStrategyOptionsRef = (0, react_1.useRef)([]);
    const dispatch = (0, store_1.useDocumentReviewDispatch)();
    const { stageTriggerTypeOptions } = (0, useStageTriggerTypes_1.default)();
    const { madeDecisionStatusCalculation, mode, roundStages } = (0, react_redux_1.useSelector)(selectors_1.default);
    const currentStage = roundStages[triggerStateModal.index];
    const isReadOnlyInComplete = (currentStage === null || currentStage === void 0 ? void 0 : currentStage.status) === 'completed';
    const isReadOnlyInProgress = (currentStage === null || currentStage === void 0 ? void 0 : currentStage.status) === 'in_progress';
    const buttonValue = react_1.default.useMemo(() => {
        switch (currentStage === null || currentStage === void 0 ? void 0 : currentStage.triggerTypeId) {
            case 1:
                return IMMEDIATE_TRIGGER_TYPE;
            case 2:
                return MANUALLY_TRIGGER_TYPE;
            default:
                return WHEN_TRIGGER_TYPE;
        }
    }, [currentStage === null || currentStage === void 0 ? void 0 : currentStage.triggerTypeId]);
    const { errors } = formikProps;
    const validStageStatusStrategy = (errors === null || errors === void 0 ? void 0 : errors.stages)
        ? !!((_a = errors === null || errors === void 0 ? void 0 : errors.stages[triggerStateModal.index]) === null || _a === void 0 ? void 0 : _a.status_strategy_id)
        : false;
    const dispatchUpdateRoundStage = (valueUpdate) => {
        dispatch((0, sliceReview_1.updateRoundStage)({
            indexStage: triggerStateModal.index,
            valueUpdate,
        }));
    };
    const onChangeDueDate = (newDueDate, deadlineType) => {
        const formattedDueDate = (0, moment_1.default)(newDueDate).format('YYYY-MM-DD h:mm:ss a');
        const deadLine = {
            deadline: formattedDueDate.toLowerCase() !== 'invalid date'
                ? formattedDueDate
                : null,
            deadlineType,
        };
        dispatchUpdateRoundStage(deadLine);
    };
    const handleChangeStageStatusStrategy = (value) => {
        dispatchUpdateRoundStage({
            stageStatusStrategy: value,
        });
    };
    (0, react_1.useEffect)(() => {
        pulse_components_1.v2Endpoint
            .get('/v2/api/stage-status-strategies?filter[exceptName]=primary_decision_maker')
            .then((res) => {
            const { data } = res;
            const statusStrategyRes = (0, utilities_1.parseJsonApi)(data);
            const convertToStatusStrategyOptions = statusStrategyRes.map((status) => {
                return (0, helper_1.statusStrategyTransform)({
                    ...status,
                    value: `${status.id}`,
                });
            });
            statusStrategyOptionsRef.current = convertToStatusStrategyOptions;
            setStatusStrategyOptions(convertToStatusStrategyOptions);
        });
        return () => {
            setStatusStrategyOptions([]);
            statusStrategyOptionsRef.current = [];
        };
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        if (madeDecisionStatusCalculation) {
            // we will use the same option Strategy and users
            const userMadeDecisionStrategy = (_a = currentStage === null || currentStage === void 0 ? void 0 : currentStage.members) === null || _a === void 0 ? void 0 : _a.filter((reviewer) => reviewer.decision).map((member) => {
                const userId = (member === null || member === void 0 ? void 0 : member.id) || (member === null || member === void 0 ? void 0 : member.userid);
                return (0, helper_1.statusStrategyTransform)({
                    id: userId,
                    value: userId,
                    userId,
                    label: `Decision made by ${member.name}`,
                    statusStrategyId: madeDecisionStatusCalculation.id,
                }, 'user');
            });
            const statusStrategyOptionsArray = (0, union_1.default)(statusStrategyOptionsRef.current, userMadeDecisionStrategy);
            setStatusStrategyOptions(statusStrategyOptionsArray);
        }
    }, [currentStage === null || currentStage === void 0 ? void 0 : currentStage.members, madeDecisionStatusCalculation]);
    const handleChangeTriggerType = (value) => {
        switch (value) {
            case IMMEDIATE_TRIGGER_TYPE:
                dispatchUpdateRoundStage({
                    triggerTypeId: 1,
                });
                break;
            case MANUALLY_TRIGGER_TYPE:
                dispatchUpdateRoundStage({
                    triggerTypeId: 2,
                });
                break;
            case WHEN_TRIGGER_TYPE:
                dispatchUpdateRoundStage({
                    triggerTypeId: 3,
                });
                break;
            default:
                break;
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        if (errors === null || errors === void 0 ? void 0 : errors.stages) {
            if (errors === null || errors === void 0 ? void 0 : errors.stages[triggerStateModal.index]) {
                dispatchUpdateRoundStage({
                    isOpen: true,
                });
            }
            const hasDeadlineError = (_a = errors.stages) === null || _a === void 0 ? void 0 : _a.some((stageError) => stageError === null || stageError === void 0 ? void 0 : stageError.deadline);
            if (mode === constants_1.MODE.newRound && hasDeadlineError) {
                utilities_1.default.notification.danger('Due date on the previous Round has passed. Please update this to proceed to the next Round.');
            }
        }
    }, [errors === null || errors === void 0 ? void 0 : errors.stages]);
    return (react_1.default.createElement(pulse_components_1.PulseModalBase, { open: triggerStateModal.isOpen, PulseModalHeaderProps: {
            onCloseClick: handleCloseModal,
            primaryText: `Stage Settings: ${currentStage === null || currentStage === void 0 ? void 0 : currentStage.nameStage}`,
            classes: {
                root: styles_modules_less_1.default['trigger-state-modal--header'],
            },
        }, isV3: true, onModalClose: handleCloseModal, onConfirmClick: handleCloseModal },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(StageSettings_1.default, { reviewers: (currentStage === null || currentStage === void 0 ? void 0 : currentStage.members) || [], indexStage: triggerStateModal === null || triggerStateModal === void 0 ? void 0 : triggerStateModal.index, stageStatusStrategy: currentStage === null || currentStage === void 0 ? void 0 : currentStage.stageStatusStrategy, stageDeadlineType: currentStage === null || currentStage === void 0 ? void 0 : currentStage.deadlineType, dueDate: currentStage === null || currentStage === void 0 ? void 0 : currentStage.deadline, onChangeDueDate: onChangeDueDate, defaultDueDate: currentStage === null || currentStage === void 0 ? void 0 : currentStage.deadline, onChangeStatusStrategy: handleChangeStageStatusStrategy, validStageStatusStrategy: validStageStatusStrategy, statusStrategyOptions: statusStrategyOptions, formikProps: formikProps, isReadOnly: isReadOnlyInComplete }),
            react_1.default.createElement(SegmentedControl_1.default, { items: groupButtons, value: buttonValue, onChange: handleChangeTriggerType, isReadOnly: isReadOnlyInComplete || isReadOnlyInProgress, disableWhenOption: roundStages.length <= 1 || triggerStateModal.index === 0 }),
            buttonValue === 'when' && roundStages.length > 1 && (react_1.default.createElement(PulseStageSelect_1.default, { isReadOnly: isReadOnlyInComplete || isReadOnlyInProgress, stageTriggerTypeOptions: stageTriggerTypeOptions, index: triggerStateModal.index, currentStage: currentStage })))));
};
exports.default = TriggerStateModal;
